import {
	deserializeDecisionMakers,
	deserializeDescription,
	deserializeLocation,
	deserializeMedia,
	deserializeScope,
	deserializeTags,
} from 'src/app/pages/petitionEditV2/shared/schemas';

import type { PetitionEditPageData } from '../../pageData';

import type { PetitionEditPageState } from './types';

export function initialState({
	petition,
	defaultPersonPhotoUrl,
	defaultOrgPhotoUrl,
}: Pick<PetitionEditPageData, 'petition'> & {
	defaultPersonPhotoUrl: string;
	defaultOrgPhotoUrl: string;
}): PetitionEditPageState {
	return {
		id: petition.id,
		formState: {
			ask: {
				value: petition.ask,
				error: null,
				dirty: false,
			},
			description: deserializeDescription({ petition }),
			geoReach: deserializeScope({ petition }),
			decisionMakers: deserializeDecisionMakers({ petition, defaultPersonPhotoUrl, defaultOrgPhotoUrl }),
			media: deserializeMedia({ petition }),
			tags: deserializeTags({ petition }),
			relevantLocation: deserializeLocation({ petition }),
		},
		uploader: null,
		saveFormError: null,
	};
}
